/*
 * Copyright © 2024 Himitsu Lab Limited. All Rights Reserved.
 */

import { Navbar, NavbarBrand } from '../Components/base/navbar/navbar'
import companyLogo from '../Assets/Images/logo.svg'
import { useNavigate } from 'react-router-dom'
import useSignOutHook from '../Hooks/SignOutHook'
import NewIcon from '../Components/base/icon/newIcons'
import { useTranslation } from 'react-i18next'
import { getCurrentUser } from '../Services/userReducer'
import { useAppSelector } from '../Store/hooks'

/**
 * A Header component that renders a navbar with a logo, language dropdown, and help link
 *
 * @return {JSX.Element} The rendered header component
 */
const Header = () => {
    const navigate = useNavigate()
    const { signOutActions } = useSignOutHook()
    const currentUser = useAppSelector(getCurrentUser)

    const handleSignOut = () => {
        signOutActions()
        window.localStorage.clear()
        navigate('/signIn')
    }
    const { t } = useTranslation();
    return (
        <header className="z-40 bg-white h-20 px-[2.5%] relative">
            <div>
                <Navbar className="text-black bg-transparent h-24 flex px-3">
                    <NavbarBrand href="/intro/choosePreference">
                        <img
                            src={companyLogo}
                            alt="logo"
                            className="h-12 w-12 m-1 pt-1"
                            id="btn_logo"
                            data-testid="btn_logo"
                        />
                    </NavbarBrand>
                </Navbar>
            </div>
            {currentUser && (
                <div className="absolute top-2 right-4">
                    <div
                        className="flex items-center cursor-pointer hover:bg-gray-100 rounded p-2 transition-colors duration-200"
                        onClick={handleSignOut}
                        title={t('signOut')}
                    >
                        <NewIcon icon="SIGNOUT" stroke="none" size="medium" />
                    </div>
                </div>
            )}
        </header>
    );
}

export default Header